import {
  Box,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  InputLabel,
  MenuItem,
  Modal,
} from "@mui/material";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { setIsLoading } from "../../../features/datatable/dataTableSlice";

import { createAnalysis } from "../../../utils/computation/analysis";
import { getScatterPlot } from "../../../utils/computation/getScatterPlot";
import { getColumnValues } from "../../../utils/computation/getColumnValues";

import Dropdown from "../../Dropdown";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "auto",
  bgcolor: "background.paper",
  p: 3,
  borderRadius: "15px",
};

const ScatterPlotModal = ({ title, closeMenu, openModal, setOpenModal }) => {
  //local states
  const [X, setX] = useState("");
  const [Y, setY] = useState("");
  const [withReg, setwithReg] = useState(false);

  //params
  const { documentId } = useParams();

  //dispatch
  const dispatch = useDispatch();

  //redux states
  const { token } = useSelector((state) => state.auth);
  const { data } = useSelector((state) => state.dataTable);

  //functions
  const handleChangeX = (event) => {
    setX(event.target.value);
  };
  const handleChangeY = (event) => {
    setY(event.target.value);
  };
  const handleOpenModal = () => {
    setOpenModal(true);
  };
  const handleCloseModal = () => {
    closeMenu();
    setOpenModal(false);
  };
  const createGraph = async () => {
    dispatch(setIsLoading());
    // get the array value of selected column
    const xvalue = getColumnValues(data, X);
    const yvalue = getColumnValues(data, Y);

    let graphResult;
    closeMenu();

    if (xvalue.length > 0 && yvalue.length > 0) {
      graphResult = await getScatterPlot({
        arr1: xvalue,
        arr2: yvalue,
        withReg,
      });

      //populate analysis object
      const graphs = {
        ...graphResult,
        column: X,
        x: X,
        y: Y,
        withReg,
        title,
      };

      try {
        // create analysis in subcollection
        const resFromCreateAnalysis = await createAnalysis(
          token,
          documentId,
          graphs
        );
        graphs.id = resFromCreateAnalysis.id;
      } catch (error) {
        return console.log("error", error);
      }
      // dispatch(addAnalysisAndGraphs(graphs));
    } else {
    }
    dispatch(setIsLoading());
  };

  return (
    <Modal
      open={openModal === title}
      onClose={handleCloseModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Grid item xs={6} p={1}>
          {/* SIMPLE */}
          {title === "Simple Scatterplot" && (
            <div>
              <h1>{title}</h1>
              <h3> Data Range</h3>
              <h3
                style={{
                  marginTop: "10px",
                }}
              >
                Select x-axis data
              </h3>
              <FormControl variant="filled" fullWidth sx={{ mt: 1 }}>
                <InputLabel id="demo-simple-select-label">
                  Select a column
                </InputLabel>
                <Dropdown value={X} onChange={handleChangeX} />
              </FormControl>
              <h3
                style={{
                  marginTop: "10px",
                }}
              >
                Select y-axis data
              </h3>
              <FormControl variant="filled" fullWidth sx={{ mt: 1 }}>
                <InputLabel id="demo-simple-select-label">
                  Select a column
                </InputLabel>
                <Dropdown value={Y} onChange={handleChangeY} />
              </FormControl>
              <FormControl variant="filled" fullWidth sx={{ mt: 1 }}>
                <h3>Additional Options</h3>

                <FormGroup>
                  <FormControlLabel
                    control={
                      <Checkbox
                        onChange={(e) => {
                          setwithReg(e.target.checked);
                        }}
                        value={withReg}
                      />
                    }
                    label="Regression line"
                  />
                </FormGroup>
              </FormControl>
              {/* <Grid
                  container
                  spacing={0}
                  direction="column"
                  alignItems="center"
                  justify="center"
                  sx={{ mt: 2 }}
                >
                  <Grid item xs={3}>
                    <Button
                      variant="contained"
                      style={{
                        width: "auto",
                        borderRadius: "7px",
                      }}
                      // onClick={() => createGraph()}
                    >
                      Add Variables
                    </Button>
                  </Grid>
                </Grid> */}
            </div>
          )}
        </Grid>

        {/* ACTION BUTTONS */}
        <div
          style={{
            display: "flex",
            float: "right",
            marginTop: "20px",
            marginBottom: "10px",
          }}
        >
          <Button
            variant="outlined"
            style={{
              borderRadius: "7px",
            }}
            onClick={handleCloseModal}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            style={{
              width: "auto",
              marginLeft: "10px",
              borderRadius: "7px",
            }}
            onClick={() => createGraph()}
          >
            Run Function
          </Button>
        </div>
      </Box>
    </Modal>
  );
};

export default ScatterPlotModal;
